import _misc from '../../assets/utils/misc.js'

export default {
  getStartingInfoFields() {
      return {
        allowAskForHelp : false,
        blocked: false,
        createdOn: new Date(),
        logo: '',
        description: '',
        description : '',
        address : '',
        acceptedPaymentForms : ['personal'],
        deliveryConfig : {
          taxes : {
            absolute : {
              description : '',
              enabled : false,
              value : 0,
            },
            byPerson : {
                description : '',
                enabled : false,
                value : 0,
            },
            percentage : {
                description : '',
                enabled : false,
                value : 1,
            }
          },
        },
        counters : {
          canceledBills : 0,
          canceledOrders : 0,
          confirmedOrders : 0,
          openBills : 0
        },
        fiscal : {
          CSC : '',
          cnpj : '',
          codIbgeFatoGerador : '',
          codRegimeTributario : '',
          endereco : {
            bairro: '',
            cUf: '',
            cep : '',
            codMunicipio : '',
            complemento : '',
            logradouro : '',
            municipio : '',
            numero : '',
            uf : ''
          },
          telefone : '',
          uf : '',
          idCSC : '',
          inscricaoEstadual : '',
          nomeFantasia : '',
          numeroSequencia : '',
          razaoSocial : ''
        },
        hours : {
          0 : {
            closeTime: "01:00",
            openTime: "08:00",
            workingDay: true
          },
          1 : {
            closeTime: "01:00",
            openTime: "08:00",
            workingDay: true
          },
          2 : {
            closeTime: "01:00",
            openTime: "08:00",
            workingDay: true
          },
          3 : {
            closeTime: "01:00",
            openTime: "08:00",
            workingDay: true
          },
          4 : {
            closeTime: "01:00",
            openTime: "08:00",
            workingDay: true
          },
          5 : {
            closeTime: "01:00",
            openTime: "08:00",
            workingDay: true
          },
          6 : {
            closeTime: "01:00",
            openTime: "08:00",
            workingDay: true
          },
        },
        latlng  : {
          Latitude : '',
          Longitude : ''
        },
        taxes : {
          absolute : {
            description : 'Entrada',
            enabled : false,
            value : 7
          },
          byPerson : {
            description : 'Corvert Artístico',
            enabled : false,
            value : 8
          },
          percentage : {
            description : 'Gorjeta',
            enabled : false,
            value: 10
          }
        }
    }
  },

  getStartingMenus () {
    let menu = {}

    let id = _misc.generateId(21);
    menu[id] = {
      description : 'Hambúrgers',
      icon: 'fastfood',
      main: false,
      order : 1
    }

    id = _misc.generateId(21);
    menu[id] = {
      description : 'Bebidas',
      icon: 'local_bar',
      main: false,
      order : 2
    }

    id = _misc.generateId(21);
    menu[id] = {
      description : 'Entradas',
      icon: 'local_cafe',
      main: true,
      order : 0
    }

    return menu
  },

  getStartingCounters () {
    let counter = []
    counter['bills'] = {
      openBills : 1
    }
    counter['orderIds'] = {
      current : 3,
      range : 1
    }
    counter['orders'] = {
      canceledOrders : 1
    }

    return counter
  }
}